// extracted by mini-css-extract-plugin
module.exports = {"cardButtons":"CardButtons_cardButtons__2-ay2","cardButton":"CardButtons_cardButton__1PzLI","bookmarkIcon":"CardButtons_bookmarkIcon__3glyb"};